console.log('Vite ⚡️ Rails')

// Entry point for the build script in your package.json
import "@hotwired/turbo-rails"
import "~/javascripts/controllers"
